export default __webpack_public_path__ + "static/media/bernygroup1.885fb442.jpg";